module.exports = __webpack_public_path__ + "static/media/student-life--spring--resized.a31b9c56.jpg";